import _ from 'lodash'
// import { createSelector } from 'reselect'

export const question = (state) => _.get(state, 'question.byCode', {})
export const isLoading = (state) => _.get(state, 'question.isLoading', {})

export const getFilters = (state) => state.question.filters;
export const getQuestions = state => state.question.questions;
export const getFamilies = state => state.question.families;
